var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit_3j2e5pv5m9io 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.3807 1.618C26.2287 -0.539332 22.729 -0.539332 20.577 1.618L6.2694 15.9203C6.15754 16.0321 6.08829 16.176 6.06698 16.3304L5.00696 24.182C4.975 24.4058 5.0549 24.6295 5.20938 24.784C5.34255 24.9171 5.52898 24.997 5.71542 24.997C5.74738 24.997 5.77934 24.997 5.8113 24.9917L10.5414 24.3525C10.9356 24.2992 11.2126 23.937 11.1593 23.5428C11.1061 23.1487 10.7439 22.8717 10.3497 22.9249L6.55704 23.4363L7.29746 17.9604L13.061 23.7239C13.1942 23.8571 13.3806 23.937 13.567 23.937C13.7535 23.937 13.9399 23.8624 14.0731 23.7239L28.3807 9.42166C29.4247 8.37762 30 6.99267 30 5.51717C30 4.04166 29.4247 2.65671 28.3807 1.618ZM20.854 3.37582L23.2564 5.77818L10.2005 18.834L7.79817 16.4316L20.854 3.37582ZM13.5724 22.2005L11.2233 19.8514L24.2791 6.79558L26.6282 9.14467L13.5724 22.2005ZM27.6296 8.11661L21.8821 2.36907C22.6118 1.76714 23.5227 1.43689 24.4815 1.43689C25.5735 1.43689 26.5962 1.86303 27.3686 2.63008C28.141 3.39713 28.5618 4.42518 28.5618 5.51717C28.5618 6.4813 28.2315 7.38685 27.6296 8.11661Z",
    fill: "#777777"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.6855856bfceaba3b3f240a05e4e84d61.svg";
export { ForwardRef as ReactComponent };